import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=9f987dec&"
import script from "./Simulation.vue?vue&type=script&lang=js&"
export * from "./Simulation.vue?vue&type=script&lang=js&"
import style0 from "./Simulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports